import React from 'react';

import Theme from 'Theme';
import Form from 'components/Form';
import config from '../../../config';

import { DetailsContain, FadeInContainer, ButtonContain } from './Styled';

export const RegisterDetails = ({ values, accountInvite, errors = [], onSubmit }) => {
  return (
    <FadeInContainer>
      <DetailsContain>
        <Form.Fields
          values={values}
          errors={errors}
          transition="slide"
          renderSubmit={(submitForm) => (
            <ButtonContain>
              <Form.Submit
                icon={'arrow_right'}
                label={'Next Step'}
                color={Theme.brandColor}
                onSubmit={() => onSubmit(submitForm())}
              />
            </ButtonContain>
          )}
        >
          <Form.TextInput
            required
            name="first_name"
            label={'First Name'}
            placeholder={'Enter your first name'}
          />
          <Form.TextInput
            required
            name="last_name"
            label={'Last Name'}
            placeholder={'Enter your last name'}
          />
          <Form.TextInput
            required
            type={'email'}
            label={'Email'}
            name="email_address"
            disabled={accountInvite}
            placeholder={'Enter your email'}
          />
          <Form.TextInput
            required
            type={'tel'}
            label={'Mobile Number'}
            name="mobile_number"
            placeholder={'Enter your mobile number'}
          />
          <Form.CheckBox
            required
            name="terms_accepted"
            displayName="Terms & Conditions"
            label={
              <span>
                I have read and accept the{' '}
                <a
                  href={`${config.api.baseUrlDownload ||
                    config.api.baseUrl}/terms.html`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {' '}
                  Terms & Conditions{' '}
                </a>
              </span>
            }
          />
        </Form.Fields>
      </DetailsContain>
    </FadeInContainer>
  );
};

export default RegisterDetails;
